const { Helmet } = require("react-helmet")

const EbanqoHelmet = () => {
    return (
        <Helmet>
            <script async type="text/javascript" onLoad={() => console.log('script loaded')} >
                {`
                    (function (w, d, s, o, f, js, fjs) {
                        w['EBANQO-WIDGET'] = o;
                    w[o] = w[o] ||
                    function () {
                        (w[o].q = w[o].q || []).push(arguments);
               };
                    (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
                    js.id = o;
                    js.src = f;
                    js.async = 1;
                    fjs.parentNode.insertBefore(js, fjs);
       })(window, document, 'script', 'ebanqo_widget', 'https://widget.ebanqo.io/app.js');
                    ebanqo_widget('init', {url: 'https://webchat.ebanqo.io/v2/FidelityPensionManagers' });
                    `}
            </script>
        </Helmet>
    )
}


export default EbanqoHelmet;